import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import PageBuilder from '../PageBuilder/PageBuilder';
import Navigation from '../Navigation/Navigation';
import WhatsAppButton from '../WhatsAppButton/WhatsAppButton';
import { getPageConfig } from '../../config/pages';
import './Page.css';

/**
 * Page - Componente que obtiene la configuración de la página según la ruta
 * y renderiza las secciones usando PageBuilder
 */
const Page = () => {
  const location = useLocation();
  const pageConfig = getPageConfig(location.pathname);

  const isInitialMount = useRef(true);

  // Scroll al anchor solo en navegación real (no en refresh)
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    const scrollTo = location.state?.scrollTo;
    if (!scrollTo) return;
    const timer = setTimeout(() => {
      document.getElementById(scrollTo)?.scrollIntoView({ behavior: 'smooth' });
    }, 50);
    return () => clearTimeout(timer);
  }, [location]);

  return (
    <>
      <Navigation />
      <main id="top" className="page-content">
        <PageBuilder sections={pageConfig.sections} />
      </main>
      <WhatsAppButton />
    </>
  );
};

export default Page;
